import { RouteStep } from '~/routes/calculations/types';

const step: RouteStep = {
  route: '/homeowners-insurance/quotes/property-address',
  isAccessible: () => true,
  breadcrumbStep: 'property',
};

export default step;
